var map = {
	"./WidgetBoolean.vue": "e3b7",
	"./WidgetDate.vue": "37ea",
	"./WidgetDateRange.vue": "e789",
	"./WidgetDateTime.vue": "2b7e",
	"./WidgetHidden.vue": "45a6",
	"./WidgetLabel.vue": "e168",
	"./WidgetLink.vue": "d2a5",
	"./WidgetMarkdown.vue": "f162",
	"./WidgetNumeric.vue": "1137",
	"./WidgetRowsPerPage.vue": "cc77",
	"./WidgetSandbox.vue": "e24d",
	"./WidgetSelect.vue": "31ed",
	"./WidgetSpace.vue": "fb24",
	"./WidgetString.vue": "0ce2",
	"./WidgetTime.vue": "9568",
	"./WidgetTimeRange.vue": "5c70",
	"./WidgetUnknown.vue": "e888",
	"./WidgetUriEncodedFile.vue": "64e1",
	"./WidgetXml.vue": "6727"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e6d";